import { ColumnSetting } from '../../../../_foundation/models/grid.models';

export const onSiteMovementColumns: ColumnSetting[] = [
  {
    field: 'type.name',
    title: 'Type',
    filter: 'string'
  },
  {
    field: 'startDateAsDateTimeString',
    title: 'Start Time',
    filter: 'date'
  },
  {
    field: 'endDateAsDateTimeString',
    title: 'End Time',
    filter: 'date'
  },
  {
    field: 'lastModifiedDateAsDateTimeString',
    title: 'Last Updated',
    filter: 'date'
  },
  {
    field: 'lastModifiedByName',
    title: 'Last Updated By',
    filter: 'text'
  },
  {
    field: 'status.name',
    title: 'Status',
    filter: 'text'
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 150
  }
];



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-list-component/on-site-movement-list-component.config.ts